import { Injectable, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { PORTAL_SERVER_URL } from '../../config';
import { BlobService } from '../utils/blob.service';

@Injectable({ providedIn: 'root' })
export class DownloadImageService implements OnDestroy {
	constructor(
		private readonly blobService: BlobService,
	) {}

	ngOnDestroy(): void {
		throw new Error('Method not implemented.');
	}

	async downloadImage(imageName: string): Promise<string | HttpErrorResponse> {
		const url = new URL(`${ PORTAL_SERVER_URL }/v1/images/${ imageName }`);
		try {
			return URL.createObjectURL(await this.blobService.getBlob(url.toString()));
		} catch (error: unknown) {
			if (error instanceof HttpErrorResponse) {
				return error;
			}
			throw error;
		}
	}
}
